"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drawable_1 = require("./drawable");
class AbstractEdge extends drawable_1.Drawable {
    constructor(startNode, endNode) {
        super(AbstractEdge.EDGE_PRIORITY);
        this.startNode = startNode;
        this.endNode = endNode;
    }
    getStartNode() {
        return this.startNode;
    }
    getEndNode() {
        return this.endNode;
    }
}
exports.AbstractEdge = AbstractEdge;
AbstractEdge.EDGE_PRIORITY = 3;
